import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { ApiService } from "../api.service";
import { CommonService } from "../common.service";
import { ActivatedRoute, Router } from "@angular/router";
import { trigger, state, style, animate, transition, query, keyframes, group } from '@angular/animations';

@Component({
	selector: 'app-case-practice-pro-nav',
	templateUrl: './case-practice-pro-nav.component.html',
	styleUrls: ['./case-practice-pro-nav.component.css']
})

export class CasePracticeProNavComponent implements OnInit, AfterViewInit {

	@Input() steps: number = 3;
	@Input() currentSteps: number = 1;
	@Input() theme:string;
	@Input() progress:number = 0;
	@Input() MaxProgress:any = [10,20,100];
	@Input() exerciseMetaId: number;
	flag:boolean=false
	stepList: any;
	constructor(

	) {}

	ngOnInit() {
		this.flag= this.exerciseMetaId === 60701 || 60702|| 60703 || 131 || 141 || 151 ? true : false
		this.stepList = [];
		for(let i = 1; i <= this.steps; i++) {
			this.stepList.push(i);
		}
	}

	ngAfterViewInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/case-practice-pro-nav/case-practice-pro-nav.component.ts